import PropTypes from 'prop-types';

import { RepromptIcon } from '@utilities';
import { formatAvailablePanelists, isContinuouslyFed } from '../../../../../../utilities/helpers';

import styles from './_index.module.scss';

const AvailablePanelists = ({ group, isLoading, status }) => {
  const getWarningText = () => {
    const isGroupContinuouslyFed = isContinuouslyFed(group);
    if (isGroupContinuouslyFed) {
      return 'Responses may collect gradually as continuously fed samples becomes available.';
    } else {
      return 'Your survey may not collect all responses based on available sample.';
    }
  };

  return (
    <div className={styles['available-panelists']}>
      <p className={styles['available-panelists-count']}>
        Available Panelists
        <span>
          {isLoading ? (
            <RepromptIcon className={styles['available-panelists-loading-icon']} />
          ) : (
            <strong>{formatAvailablePanelists(group)}</strong>
          )}
        </span>
      </p>
      {!isLoading && status === 'warn' && (
        <p className={styles['available-panelists-warning']}>{getWarningText()}</p>
      )}
    </div>
  );
};

AvailablePanelists.propTypes = {
  group: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  status: PropTypes.string,
};

export default AvailablePanelists;
